import React from 'react';
import { LIST_BETS_MOBILE } from '../data/constants';
import { filtraParametriche } from '../data/utils/filtraParametriche';
import { getBetDescription } from '../data/utils/getBetDescription';
import { getConfiguration } from '../data/utils/configuration';
import { getNumberOfColsMobile } from '../data/utils/getNumberOfColsMobile';
import HandicapSelector from '../HandicapSelector';
import { useGetOffsetClass } from '../utils/useGetOffsetClass';
import ListBetSelector from './ListBetSelector';
import Odd from './Odd';
import ScorerOddsSelector from './ScorerOddsSelector';

function Bet(props) {
    const offsetClass = useGetOffsetClass();
    const conf = getConfiguration();

    const [bet, odds] = [props.data, props.data.odds];

    const colsNumber = getNumberOfColsMobile(odds.length);
    let oddDescTooLong = false;
    const oddsComponents = odds.map(o => {
        if (!oddDescTooLong) {
            if (conf.iwh && colsNumber === 2 && odds.length < 3) {
                oddDescTooLong = false;
            }
            else if (conf.iwh && colsNumber === 3) {
                oddDescTooLong = false;
            }
            else if (conf.iwh && odds.length > 3) {
                oddDescTooLong = true
            }
            else if (colsNumber === 2 && o.desc?.length > 6) {
                oddDescTooLong = true;
            }
            else if (colsNumber === 3 && o.desc?.length > 3) {
                oddDescTooLong = true;
            }
        }
        return <Odd key={o.uniqueId || o.id} data={o} noHandicap={true} />
    });

    const desc = getBetDescription(bet, false);

    return (
        <div key={bet.uniqueId || bet.id}>
            <div className={`sticky ${offsetClass} h-full text-center font-medium text-xs uppercase bg-cs1 desc-betContainer-wh ${desc} bet-id${bet.id}`}>{desc}</div>
            {oddDescTooLong ?
                <div className={`grid xs-flow-row gap-1 bet-id${bet.id}`}>
                    {oddsComponents}
                </div>
                :
                <div className={`grid xs-cols-layout-${colsNumber} gap-1 bet-id${bet.id}`}>
                    {oddsComponents}
                </div>
            }
        </div>
    );
}

export default function BetsContainer(props) {
    const bets = filtraParametriche(props.bets);
    const hcpBetsById = props.betsById;

    return (
        <>
            {bets.map((b, index) => {
                let odds = b.odds;
                {/* if (!props.isLive) {
                    odds = b.odds.filter(o => o.value != null);
                } */}

                if (b.parametrica) {
                    const bets = hcpBetsById.get(b.id);
                    if (bets.length === 0) {
                        return null;
                    }
                    if (bets.length > 1) {
                        let component = null;

                        if (bets[0].tipoHandicap === 38) {
                            component = <ScorerOddsSelector bets={bets} stickyDesc={true} />
                        } else if (LIST_BETS_MOBILE.includes(bets[0].tipoHandicap)) {
                            component = <ListBetSelector bets={hcpBetsById.get(b.id)} stickyDesc={true} />;
                        }
                        component = <HandicapSelector bets={hcpBetsById.get(b.id)} stickyDesc={true} />;

                        return (
                            <div key={b.uniqueId || b.id} className="mt-1">
                                {component}
                            </div>
                        )
                    }
                }

                if (odds.length === 0) {
                    return null;
                }

                return <Bet key={`${b.uniqueId}_${index}`} data={b} />;
            })}
        </>
    );
}
